export const initialTemplateValues = (variables = [], currentValues = {}) =>
  variables.reduce((values, variable) => {
    if (Object.prototype.hasOwnProperty.call(currentValues, variable.key)) {
      values[variable.key] = currentValues[variable.key];
    } else if (variable.default !== undefined) {
      values[variable.key] = variable.default;
    } else if (variable.type === "boolean") {
      values[variable.key] = false;
    } else {
      values[variable.key] = "";
    }
    return values;
  }, {});

export const runtimeDefaultsFromTemplate = (template, models = []) => {
  const recommendations = template?.publishedVersion?.recommendations || {};
  const recommendedModel = recommendations.modelId;
  const model =
    models.find(
      (item) => item.modelId === recommendedModel && item.availableForNewUse
    ) ||
    models.find((item) => item.recommended && item.availableForNewUse) ||
    models.find((item) => item.availableForNewUse);
  return {
    model: model?.modelId || recommendedModel || "",
    maxTokens: Number(recommendations.maxTokens || 700),
    temperature: Number(recommendations.temperature ?? 0.4),
    maxMessages: Number(recommendations.maxMessages || 12),
  };
};

export const mergePreviewWithoutLosingCustomization = ({
  instructionsMode,
  customInstructions,
  generatedPrompt,
}) => ({
  generatedPrompt,
  customInstructions:
    instructionsMode === "custom" && !customInstructions
      ? generatedPrompt
      : customInstructions,
});

export const enableTemplateInstructionEditing = ({
  customInstructions,
  generatedPrompt,
} = {}) => ({
  instructionsMode: "custom",
  customInstructions: customInstructions || generatedPrompt || "",
  confirmReplaceCustomInstructions: false,
});

export const credentialOptionsForPurpose = (
  credentials = [],
  purpose,
  provider
) =>
  credentials.filter(
    (credential) =>
      credential.configured &&
      credential.status === "active" &&
      credential.purpose === purpose &&
      (!provider || credential.provider === provider)
  );

export const credentialOptionsForModel = (
  credentials = [],
  models = [],
  modelId = ""
) => {
  const provider = models.find((model) => model.modelId === modelId)?.provider;
  return credentialOptionsForPurpose(credentials, "chat", provider);
};

export const templateAgentSaveBlockers = ({
  form = {},
  variables = [],
  knowledgeRequirement = "optional",
} = {}) => {
  const blockers = [];
  const name = String(form.name || "").trim();

  if (name.length < 5 || name.length > 100) {
    blockers.push("Informe um nome entre 5 e 100 caracteres.");
  }

  variables
    .filter((variable) => variable.required)
    .forEach((variable) => {
      const value = form.values?.[variable.key];
      if (value === undefined || value === null || String(value).trim() === "") {
        blockers.push(`Preencha ${variable.label || variable.key}.`);
      }
    });

  if (!String(form.model || "").trim()) {
    blockers.push("Selecione um modelo.");
  }
  if (!Number.isInteger(Number(form.credentialId)) || Number(form.credentialId) <= 0) {
    blockers.push("Selecione uma credencial de conversa.");
  }
  if (!Number.isInteger(Number(form.queueId)) || Number(form.queueId) <= 0) {
    blockers.push("Selecione uma fila.");
  }

  const knowledge = form.knowledge || {};
  if (
    knowledgeRequirement === "required" &&
    !(knowledge.knowledgeBaseIds || []).length
  ) {
    blockers.push("Selecione ao menos uma base de conhecimento aprovada.");
  }
  if (
    knowledge.mode !== "disabled" &&
    knowledge.fallbackAction === "handoff" &&
    (!Number.isInteger(Number(knowledge.fallbackQueueId)) ||
      Number(knowledge.fallbackQueueId) <= 0)
  ) {
    blockers.push("Selecione a fila de encaminhamento do fallback.");
  }

  return blockers;
};
